<template>
  <v-card class="main-content-card" flat>
    <v-card-text>
      <h2 class="subheading"><v-icon class="mr-1" color="red">lock</v-icon>无权限访问该页面！</h2>
    </v-card-text>
  </v-card>
</template>

<script>
  export default {
    data: () => ({}),

    computed: {},

    created() {

    },

    methods: {}
  }
</script>
<style scoped>
  div.stepper__content {
    padding: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/403.vue